export default __webpack_public_path__ + "static/media/section2_bg_1.2d980a00.png";